import { DashboardModel } from '../../models/model'

export interface DashboardState extends DashboardModel {}

export const initialUserDashboardState: DashboardState = {
  announcements: [],
  calendarEvents: []
}
